export default "/images/favourite-small-selected.svg?a098247f3c9a76a318b7edf7d2e40c77";